import Button from 'content-components/_Primatives/Button'

import style from './style.scss'

export type Props = {
  bodyText: string
  link: {
    text: string
    url: string
  }
}

function ResumeCourseBanner({ bodyText, link }: Props) {
  const { url, text } = link

  return (
    <div className={style.wrapper}>
      <p className={style.text}>{bodyText}</p>
      <Button className={style.button} url={url} target='_self'>
        {text}
      </Button>
    </div>
  )
}

export default ResumeCourseBanner
